export const GET_PROFESSION_START = 'GET_PROFESSION_START';
export const GET_PROFESSION_SUCCESS = 'GET_PROFESSION_SUCCESS';
export const GET_PROFESSION_ERROR = 'GET_PROFESSION_ERROR';
export const GET_PROFESSION_END = 'GET_PROFESSION_END';
